export interface MovePathPoint {
  q: number
  r: number
}

export const HOP_DURATION_PER_STEP = 0.28
export const MIN_HOP_DURATION = 0.35

export function getHopCount(path?: MovePathPoint[]): number {
  return Math.max(1, (path?.length ?? 0) - 1)
}

export function getMoveDurationSeconds(path?: MovePathPoint[]): number {
  return Math.max(MIN_HOP_DURATION, getHopCount(path) * HOP_DURATION_PER_STEP)
}

export function getMoveDurationMs(path?: MovePathPoint[]): number {
  return getMoveDurationSeconds(path) * 1000
}
